import { cookieNames } from "@/constants";
import { ProductData } from "@/lib/5874/types";
import { getProductsBySkus } from "@/lib/bigcommerce/product";
import isServer from "@/utils/is-server";
import { useEffect, useState } from "react";

const useGetViewedItemsFromLocalStorage = (currentItemId?: number) => {
	const [items, setItems] = useState<ProductData[]>([]);
	const [isLoadingItems, setIsLoadingItems] = useState(true);

	const cookieKey = cookieNames.RECENTLY_VIEWED;

	const getProductData = async () => {
		if (isServer()) {
			setIsLoadingItems(false);
			return;
		}

		const skus = localStorage.getItem(cookieKey)?.split(",") || [];
		const products = await getProductsBySkus(skus);

		const filtered = currentItemId
			? products?.filter((p) => p.id !== currentItemId)
			: products;
		filtered && setItems(filtered);

		setIsLoadingItems(false);
	};

	const handleStorageChange = (event: StorageEvent) => {
		const key = event.key;

		// only listen for cookieKey changes
		if (key !== cookieKey) {
			return;
		}

		getProductData();
	};

	useEffect(() => {
		// initial load
		getProductData();

		// listen for storage changes if we're in the browser
		if (!isServer()) {
			window.addEventListener("storage", handleStorageChange);
		}

		// cleanup
		return () => {
			if (!isServer()) {
				window.removeEventListener("storage", handleStorageChange);
			}
		};
	}, []);

	return { isLoadingItems, items };
};

export default useGetViewedItemsFromLocalStorage;
